import { Properties } from "csstype"
import { DOMAttributes, forwardRef, InputHTMLAttributes } from "react"
import { CssInput } from "./style"

type InputType =
	| "button"
	| "checkbox"
	| "color"
	| "date"
	| "datetime-local"
	| "email"
	| "file"
	| "hidden"
	| "image"
	| "month"
	| "number"
	| "password"
	| "radio"
	| "range"
	| "reset"
	| "search"
	| "submit"
	| "tel"
	| "text"
	| "time"
	| "url"
	| "week"

interface InputProps {
	placeholder: string
	type: InputType

	required?: boolean

	style?: Properties

	value: string | number
	onChange: ((value: string) => void) | ((value: number) => void)
}

export const Input = forwardRef<
	HTMLInputElement,
	InputProps & DOMAttributes<HTMLInputElement> & InputHTMLAttributes<HTMLInputElement>
>(
	(
		{
			placeholder = "",
			type = "text",
			required = false,
			style = undefined,
			value = undefined,
			onChange = undefined,
			...rest
		},
		ref
	) => {
		return (
			<CssInput
				ref={ref}
				placeholder={placeholder}
				type={type}
				value={value}
				onChange={({ target: { value } }) => onChange?.(value as any)}
				required={required}
				style={style}
				{...rest}
			/>
		)
	}
)
